import React from 'react';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import { useRateStore } from '../store/RateStore';

const EquivToggle = () => {
    const store = useRateStore();

    const handleEquivChange = (e) => {
        store.setIsEquiv(e.target.checked);
    };

    return (
        <div
            style={{
                display: 'inline-flex',
                float: 'right',
            }}
            className="unselectable"
        >
            <div>Equiv</div>
            <Toggle
                checked={store.isEquiv ?? false}
                onChange={handleEquivChange}
                icons={false}
            />
        </div>
    );
};

export default EquivToggle;
